<section class="section section-1">

  <div class="container">

    <div class="text-center mb-5">

      <span class="section-badge">
        {{ 'howItWorks.badge' | translate }}
      </span>

      <h2 class="section-title">
        {{ 'howItWorks.title' | translate }}
      </h2>

      <p class="section-subtitle">
        {{ 'howItWorks.subtitle' | translate }}
      </p>

    </div>

    <div class="row">

      @for (step of steps; track step; let i = $index) {

      <div class="mt-5 col-md-6 col-lg-3" style>

        <div class="step-number">
          {{ i + 1 }}
        </div>

        <div class="step-card">

          <div class="step-icon">
            <i class="fas {{ step.icon }}"></i>
          </div>

          <h5>
            {{ step.title }}
          </h5>

          <p>
            {{ step.description }}
          </p>

        </div>

      </div>

      }

    </div>

  </div>

</section>